import * as api from './../register_api_services/Salary_register.api';
import * as actionTypes from './../Register_action.types';

export const uploadSalaryRegisterRequest = (fileData) => ({
  type: actionTypes.UPLOAD_SALARY_REGISTER_REQUEST,
  payload: fileData,
});

export const uploadSalaryRegisterSuccess = (fileData) => ({
  type: actionTypes.UPLOAD_SALARY_REGISTER_SUCCESS,
  payload: fileData,
});

export const uploadSalaryRegisterFailure = (error) => ({
  type: actionTypes.UPLOAD_SALARY_REGISTER_FAILURE,
  payload: error,
});

export const uploadSalaryRegisterFile = (fileData) => {
  return async (dispatch) => {
    dispatch(uploadSalaryRegisterRequest(fileData));
    try {
      const response = await api.uploadSalaryRegister(fileData);
      dispatch(uploadSalaryRegisterSuccess(response));
      return { success: true, message: response };
    } catch (error) {
      dispatch(uploadSalaryRegisterFailure(error));
      return { success: false, message: error };
    }
  };
};
export const multiDaleteSalaryRegisterRequest = (ids) => ({
  type: actionTypes.MULTI_DELETE_SALARY_REGISTER_REQUEST,
  payload: ids,
});

export const multiDaleteSalaryRegisterSuccess = (message) => ({
  type: actionTypes.MULTI_DELETE_SALARY_REGISTER_SUCCESS,
  payload: message,
});

export const multiDaleteSalaryRegisterFailure = (error) => ({
  type: actionTypes.MULTI_DELETE_SALARY_REGISTER_FAILURE,
  payload: error,
});

export const multiDeleteSalaryRegisterFile = (ids) => {
  console.log(ids);
  return async (dispatch) => {
    dispatch(multiDaleteSalaryRegisterRequest(ids));
    try {
      const response = await api.multiDeleteSalaryRegister(ids);
      dispatch(multiDaleteSalaryRegisterSuccess(response));
      return { success: true, message: response };
    } catch (error) {
      dispatch(multiDaleteSalaryRegisterFailure(error));
      return { success: false, message: error };
    }
  };
};


export const getSalaryRegisterRequest = () => ({
  type: actionTypes.GET_SALARY_REGISTER_REQUEST,
});

export const getSalaryRegisterSuccess = (clients) => ({
  type: actionTypes.GET_SALARY_REGISTER_SUCCESS,
  payload: clients,
});

export const getSalaryRegisterFailure = (error) => ({
  type: actionTypes.GET_SALARY_REGISTER_FAILURE,
  payload: error,
});

export const getSalaryRegister = (current_month) => {
  return async (dispatch) => {
    dispatch(getSalaryRegisterRequest());
    try {
      const response = await api.fetchSalaryRegister(current_month);
      dispatch(getSalaryRegisterSuccess(response));
      return { success: true, data: response };
    } catch (error) {
      dispatch(getSalaryRegisterFailure(error));
      return { success: false, message: error };
    }
  };
};

export const updateSalaryRegisterRequest = (id, clientData) => ({
  type: actionTypes.UPDATE_SALARY_REGISTER_REQUEST,
  payload: { id, clientData },
});

export const updateSalaryRegisterSuccess = (message) => ({
  type: actionTypes.UPDATE_SALARY_REGISTER_SUCCESS,
  payload: message,
});

export const updateSalaryRegisterFailure = (error) => ({
  type: actionTypes.UPDATE_SALARY_REGISTER_FAILURE,
  payload: error,
});

export const updateSalaryRegisterById = (id, salaryData) => {
  return async (dispatch) => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    salaryData.updated_by = user.user_name;

    dispatch(updateSalaryRegisterRequest(id, salaryData));
    try {
      const response = await api.updateSalaryRegister(id, salaryData);
      dispatch(updateSalaryRegisterSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(updateSalaryRegisterFailure(error));
      return { success: false, message: error };
    }
  };
};
export const deleteSalaryRegisterRequest = (id) => ({
  type: actionTypes.DELETE_SALARY_REGISTER_REQUEST,
  payload: id,
});

export const deleteSalaryRegisterSuccess = (message) => ({
  type: actionTypes.DELETE_SALARY_REGISTER_SUCCESS,
  payload: message,
});

export const deleteSalaryRegisterFailure = (error) => ({
  type: actionTypes.DELETE_SALARY_REGISTER_FAILURE,
  payload: error,
});

export const deleteSalaryRegisterRegisterById = (id) => {
  return async (dispatch) => {
    dispatch(deleteSalaryRegisterRequest(id));
    try {
      const response = await api.deleteSalaryRegister(id);
      dispatch(deleteSalaryRegisterSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(deleteSalaryRegisterFailure(error));
      return { success: false, message: error };
    }
  };
};
